/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';

export interface AttributeGroup {
  active?: boolean;
  attributeGroupId?: number;
  attributeGroupName?: string;
  attributeGroupQuestion?: string;
  attributeGroupReferenceId?: number;
  attributes?: Array<Attribute>;
  businessUnitId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  groups?: Array<AttributeGroup>;
  order?: number;
}
